import { DataLayer } from '@by-miles/data-layer'
import { useContext, useEffect, useState } from 'react'

import { useQuote } from '../../../../../../../hooks/useQuote'
import { useCarPageContext } from '../../../../../../../pages/CarPageProvider'
import { usePreQuoteContext } from '../../../../../../../pages/PageValidator'
import { ProviderContext } from '../../../../../../../Provider'
import { Ownership } from '../Ownership'

export const OwnershipContainer = () => {
  const quote = useQuote()
  const { handleUpdateCarDetails, ownersData } = useCarPageContext()
  const { showErrorBanner, notAnsweredMessage, updateValidInputs, validInputs } = usePreQuoteContext()

  const {
    state: { isMobile },
  } = useContext(ProviderContext)

  const [legalOwner, setLegalOwner] = useState<string>(quote?.details?.vehicle?.owner || '')
  const [keeper, setKeeper] = useState<string>(quote?.details?.vehicle?.keeper || '')

  const handleLegalOwner = (owner: string) => {
    setLegalOwner(owner)
    DataLayer.customEvent({
      eventName: 'legal owner',
      section: 'car',
      eventType: 'form tracking',
    })
    handleUpdateCarDetails({ owner })
  }

  const handleKeeper = (keeper: string) => {
    setKeeper(keeper)
    DataLayer.customEvent({
      eventName: 'registered keeper',
      section: 'car',
      eventType: 'form tracking',
    })
    handleUpdateCarDetails({ keeper })
  }

  useEffect(() => {
    updateValidInputs({ field: 'keeper', value: !!keeper })
  }, [keeper])

  useEffect(() => {
    updateValidInputs({ field: 'legalOwner', value: !!legalOwner })
  }, [legalOwner])

  return (
    <Ownership
      showErrorBanner={showErrorBanner}
      notAnsweredMessage={notAnsweredMessage}
      dropDownOptions={ownersData?.owners || []}
      handleLegalOwner={handleLegalOwner}
      legalOwner={legalOwner}
      legalOwnerValid={validInputs?.legalOwner}
      isMobile={isMobile}
      keeper={keeper}
      handleKeeper={handleKeeper}
      keeperValid={validInputs?.keeper}
    />
  )
}
